module.exports = __webpack_public_path__ + "static/media/mbti_banner1.dcc63f53.jpg";